import { SignUp } from '@web/features/auth/sign-up';
import { BaseLayout } from '@web/features/layouts/base';

/**
 * # VIP Register Page
 */
export default function VIPRegisterPage() {
  return (
    <BaseLayout withHomeButton>
      <SignUp />
    </BaseLayout>
  );
}
